import React from 'react';
import { useIntl } from 'react-intl';

import { TranslationKeys } from 'app/translations';
import { EmploymentContractTypeEnum } from '../types/employee.types';

export const useEmploymentContractTypeSelectItems = () => {
  const intl = useIntl();

  const employmentContractTypeSelectItems = React.useMemo(() => {
    return [
      {
        value: EmploymentContractTypeEnum.Indefinite,
        label: intl.formatMessage({ id: TranslationKeys.global_contractType_indefinite }),
        element: intl.formatMessage({ id: TranslationKeys.global_contractType_indefinite }),
      },
      {
        value: EmploymentContractTypeEnum.Definite,
        label: intl.formatMessage({ id: TranslationKeys.global_contractType_definite }),
        element: intl.formatMessage({ id: TranslationKeys.global_contractType_definite }),
      },
    ];
  }, [intl]);

  const getEmploymentContractTypeDisplayNameByValue = React.useCallback(
    (value: EmploymentContractTypeEnum | string) => {
      return employmentContractTypeSelectItems.find(item => item.value === value)?.label ?? '';
    },
    [employmentContractTypeSelectItems],
  );

  return { employmentContractTypeSelectItems, getEmploymentContractTypeDisplayNameByValue };
};
